import styles from "./SectionContentProductServiceV2.module.scss";

const SectionContentProductServiceV2 = ({ children, style = {} }) => {
    return (
        <section className={styles.container} style={{ ...style }}>
            {children}
        </section>
    );
};

export default SectionContentProductServiceV2;
